import { useCallback } from 'react';
import { useConsentStore } from '../store/consentStore';

export default function useConsentGuard() {
  const consentRequired = useConsentStore((state) => state.consentRequired);
  const showConsentModal = useConsentStore((state) => state.showConsentModal);

  const requireConsent = useCallback(
    (action, trigger = 'generate') => {
      if (typeof action !== 'function') {
        throw new TypeError('requireConsent expects an action function');
      }

      if (consentRequired !== true) {
        return action();
      }

      showConsentModal(action, trigger);
      return undefined;
    },
    [consentRequired, showConsentModal],
  );

  return { requireConsent };
}
